<style>
    .adjust-product-tips {
        position: absolute;
        top:0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255,255,255,.9);
        color: #48576a;
    }
</style>
<template>
    <div class="p20">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">修改收款账户</h1>
            </el-col>
            <el-col :span="12" class="tr">
                <el-button type="primary" @click="submit" size="small" :loading="submitLoad">
                    <i class="fa fa-save" v-if="!submitLoad"></i>&nbsp;提交
                </el-button>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <!-- 表单列表 start -->
        <el-card class="box-card mt15">
            <Ly-search-form 
                :config="formConfig" 
                :rules="formRules"
                :is-search="false"
                label-width="120px"
                ref="searchForm"
                v-model="formValue">
            </Ly-search-form>
        </el-card>
        <!-- 表单列表 end -->
    </div>
</template>
<script>
    import AddFormConfig from './edit-form'
    import AddRulesConfig from './rules'

    import LySearchForm from '@c/search-form'
    import LyRouterButton from '@c/router-button'

    import {mapGetters} from 'vuex'
    export default {
        mixins: [
            AddFormConfig,
            AddRulesConfig
        ],
        components: {
            LySearchForm,
            LyRouterButton
        },
        computed: {
            ...mapGetters([
                'userInfo'     
            ])
        },
        data () {
            return {
                loading: true,
                submitLoad: false, // 提交按钮的状态标识
                // 表单输入内容
                formValue: {},
                infoId: 0, // 详情的ID
                submitForm: {} // 提交的表单数据
            }
        },
        created () {
            this.init()
        },
        watch: {
            '$route' (to, from) {
                // 路由变化时，更新配置
                if (to.name === 'BankAccountEdit') {
                    this.init()
                }
            }
        },
        methods: {
            init () {
                // 获取详情的ID
                this.infoId = this.$route.params.id
                if (this.infoId) {
                    this.queryEditData()
                } else {
                    this.$message({
                        message: '无ID',
                        type: 'warning'
                    })
                }
            },
            /**
             * 获取要修改的数据
             */
            queryEditData () {
                this.$api.queryArr(['api/bankaccount', 'edit'], null, [this.infoId]).then((rs) => {
                    this.submitForm = rs
                    // 设置表单中的回填数据
                    this.$refs['searchForm'].initBindFormData(rs)
                    // 设置UUID
                    this.submitForm.uuid = this.$utils.createUUID()
                }).catch((error) => {
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            submit () {
                if (this.$refs['searchForm'].validateForm()) {
                    this.submitLoad = true
                    // 获得得查询的字段
                    this.submitForm = Object.assign(this.submitForm, this.$refs['searchForm'].bindForm)
                    // 提交数据
                    this.$api.save('api/bankaccount/' + this.infoId, this.submitForm).then((rs) => {
                        this.$alert('数据提交成功', '修改', {
                            confirmButtonText: '确定',
                            callback: action => {
                                this.submitLoad = false
                                // 跳转到详情页面
                                this.$router.push('/bill/bankaccount/info/' + rs.id)
                            }
                        });
                        // 更新UUID
                        this.submitForm.uuid = this.$utils.createUUID()
                    }).catch((error) => {
                        this.submitLoad = false
                        this.$message({
                            message: error,
                            type: 'warning'
                        })
                    })
                } else {
                    this.$message({
                        message: '请将信息填写完整',
                        type: 'warning'
                    })
                }
            }
        }
    }
</script>